export const name = 'discardAssetsLibrariesSelectionController';
export default function discardAssetsLibrariesSelectionController($mdDialog, $log) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

  vm.cancel = cancel;
  vm.discardSelection = discardSelection;

  function cancel(data) {
    let functionName='discardAssetslibrariesSelectionController.cancel';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    $mdDialog.cancel();
  }

  function discardSelection() {
    let functionName='discardAssetslibrariesSelectionController.discardSelection';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    $mdDialog.hide();
  }
}
